import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box } from '@wix/design-system';
import { TldPromotionsSkeleton } from './TldPromotionsSkeleton';
import { TldPromotionComp } from './TldPromotion/TldPromotion';
export const TldPromotions = _ref => {
  let {
    promotions,
    isLoading,
    dataHook,
    Label,
    PromotionBadge,
    PromotionPrice
  } = _ref;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(TldPromotionsSkeleton, {
      limit: 8
    });
  }
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHook,
    width: "100%",
    display: "block",
    borderRadius: "12px",
    border: "1px solid #DEDEDE",
    overflow: "hidden",
    padding: "38px 0"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(max(250px, calc(25% - 16px)), 1fr))",
    gap: "50px 0",
    width: "100%",
    position: "relative"
  }, promotions.map(promotion => /*#__PURE__*/React.createElement(TldPromotionComp, _extends({
    key: promotion.id
  }, promotion, {
    Label: Label,
    PromotionBadge: PromotionBadge,
    PromotionPrice: PromotionPrice
  })))));
};
//# sourceMappingURL=TldPromotions.js.map